<template>
  <div class="client-user-wrap">
    <!-- <span class="float-bg __lt">
      <img src="@/assets/img/bg_home.png" />
    </span>
    <span class="float-bg __rb">
      <img src="@/assets/img/bg_home.png" />
    </span> -->
    <el-row class="content-wrap">
      <el-col :span="6" class="side-left">
        <div class="__left-inner">
          <AsideLeft :siteIds="siteIds"></AsideLeft>
        </div>
      </el-col>
      <el-col :span="18" class="content-right">
        <div class="__right-inner">
          <div class="top-box">
            <client-user-header></client-user-header>
          </div>
          <div class="scroll-box">
            <div class="mid-box">
              <mid-policy></mid-policy>
            </div>
            <el-row class="bottom-box">
              <el-col :span="8" class="__kee">
                <kee></kee>
              </el-col>
              <el-col :span="16" class="__tools">
                <div class="__inner">
                  <tech-transformation></tech-transformation>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <v-bottom></v-bottom>
  </div>
</template>
<script>
import SvgIcon from "@/components/svgIcon/index";
import AsideLeft from './AsideLeft.vue'
import ClientUserHeader from './ClientUserHeader.vue'
import MidPolicy from './MidPolicy.vue'
import Kee from './KEE.vue'
import TechTransformation from './TechTransformation.vue'
import vBottom from '@/components/common/Bottom'


export default {
  name: 'ClientUserWrap',
  components: {
    SvgIcon,
    AsideLeft,
    ClientUserHeader,
    MidPolicy,
    Kee,
    TechTransformation,
    vBottom
  },
  data() {
    return {}
  },
  props: {
    siteIds: {
      type: String,
      default: ''
    }
  },
  mounted() { },
  methods: {}
}
</script>

<style scoped>
/* bg start */
.float-bg {
  position: absolute;
  display: inline-block;
}

.float-bg.__lt {
  top: 60px;
  left: -60px;
}
.float-bg.__lt img {
  width: 400px;
}

.float-bg.__rb {
  bottom: -70px;
  right: -130px;
}
.float-bg.__rb img {
  width: 600px;
}
/* bg end */

.client-user-wrap {
  width: 100%;
  height: calc(100% - 46PX);
  background-color: #ebebeb;
  position: relative;
  /* overflow: hidden; */
  overflow: auto;

  /* 卡片容器之间的间距 */
  --spacing: 15px;
  --top-header-height: 60PX;
}

.content-wrap {
  width: 1480PX;
  min-width: 1480PX;
  height: 100%;
  margin: 0 auto;
}

.side-left {
  height: 100%;
  padding-right: var(--spacing);
}
.__left-inner {
  width: 100%;
  height: 100%;
}

.content-right {
  height: 100%;
}

.__right-inner {
  width: 100%;
  height: 100%;
}
.__right-inner .top-box {
  width: 100%;
  height: var(--top-header-height);
}

.__right-inner .scroll-box {
  height: calc(100% - var(--top-header-height));
  overflow: auto;
  padding-bottom: var(--spacing);
}

.__right-inner .scroll-box::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6PX !important; /*高宽分别对应横竖滚动条的尺寸*/
    height: 6PX !important;
}

.__right-inner .mid-box {
  width: 100%;
  /* height: calc(49% - var(--top-header-height)); */
  height: 315PX;
  border-radius: 10px;
  background-color: #fff;
}
.__right-inner .bottom-box {
  width: 100%;
  height: calc(100% - 315PX - var(--spacing));
  min-height: 400PX;
  margin-top: var(--spacing);
}
.__right-inner .bottom-box .__tools {
  height: 100%;
  padding-left: var(--spacing);
}
.bottom-box .__tools .__inner {
  height: 100%;
  border-radius: 10px;
  background-color: #fff;
}
.__right-inner .bottom-box .__kee {
  height: 100%;
  border-radius: 10px;
  background-color: #fff;
  padding: 0 var(--spacing);
}
</style>